import React from "react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
} from "@heroui/react";
import { CaretDown, EnvelopeOpen } from "@phosphor-icons/react";

interface MessageActionsMenuProps {
  /** Called when the user picks "Markeer als ongelezen" — caller does the BE call */
  onMarkUnread: () => void;
  /** Tints the caret to match the bubble background */
  tone?: "outbound" | "inbound";
}

/**
 * Small WhatsApp-style caret-down trigger that appears on hover of a message bubble.
 * Opens a dropdown with per-message actions.
 */
export const MessageActionsMenu: React.FC<MessageActionsMenuProps> = ({
  onMarkUnread,
  tone = "inbound",
}) => {
  const caretColor =
    tone === "outbound" ? "text-neutral-secondary-mid" : "text-neutral-secondary-mid";

  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <button
          type="button"
          aria-label="Berichtacties"
          className={`absolute right-1 top-1 rounded-full p-0.5 opacity-0 transition-opacity hover:bg-black/5 group-hover:opacity-100 ${caretColor}`}
          onClick={(e) => e.stopPropagation()}
        >
          <CaretDown size={14} weight="bold" />
        </button>
      </DropdownTrigger>
      <DropdownMenu aria-label="Berichtacties">
        <DropdownItem
          key="mark-unread"
          startContent={<EnvelopeOpen size={16} weight="duotone" />}
          onPress={onMarkUnread}
        >
          Markeer als ongelezen
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default MessageActionsMenu;
